import { Component, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { concatMap, tap } from 'rxjs/operators';

import { Offer } from 'graphql/models/extended';
import { LineSubtypePropVal } from 'models/position.model';
import { OfferPricing } from 'models/pricing.model';
import {
  AddLooseArticleToOfferComponent
} from 'shared/forms/loose-categories/add-loose-article-to-offer/add-loose-article-to-offer.component';
import { OfferPositionService } from 'shared/services/offer-position.service';
import { StoreService } from 'shared/services/store.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-add-loose-article-to-offer-modal',
  templateUrl: './add-loose-article-to-offer-modal.component.html',
  styleUrls: ['./add-loose-article-to-offer-modal.component.scss']
})

export class AddLooseArticleToOfferModalComponent {
  data!: string;

  @ViewChild(
    AddLooseArticleToOfferComponent,
    { static: false }
  ) addLooseArticleToOfferComponent!: AddLooseArticleToOfferComponent;

  get form(): UntypedFormGroup {
    return this.addLooseArticleToOfferComponent.form;
  }

  constructor(
    private offerPositionService: OfferPositionService,
    private storeService: StoreService,
    private bsModalRef: BsModalRef
  ) {
  }

  onSubmit(): Observable<any> {
    this.bsModalRef.content.bsModalRef.content.showLoadingOverlay = true;
    const productId = String(this.addLooseArticleToOfferComponent.selectedLooseArticle.id);
    const offer = this.addLooseArticleToOfferComponent.offer;
    let positionId = this.addLooseArticleToOfferComponent.position.id;
    let updatedOfferPricing: OfferPricing;
    let updatedOfferPricingState: {
      autoUpdatePrices?: boolean,
      priceIsOutdated?: boolean
    };

    return this.offerPositionService.deletePositions(offer, [positionId])
      .pipe(
        concatMap(() => this.offerPositionService.addProductPositionCustom(offer, productId)),
        concatMap((newPositionId) => {
          positionId = newPositionId;

          return this.offerPositionService.updateAllPositionFields(
            offer,
            positionId,
            this.form.controls.quantity.value,
            this.form.controls.description.value,
            this.form.controls.number.value,
            this.form.controls.text.value,
            productId,
            LineSubtypePropVal.LOOSE_ARTICLE
          ).pipe(
            tap((uOffer: Offer) => {
              updatedOfferPricing = uOffer.pricing as OfferPricing;
              updatedOfferPricingState = {
                autoUpdatePrices: uOffer.autoUpdatePrices,
                priceIsOutdated: uOffer.priceIsOutdated
              };
            })
          );
        }),
        concatMap(() => this.offerPositionService.getLooseArticleProductPosition(offer, positionId)),
        tap((productPositions) => {
          return this.storeService.setOfferUpdate({
            offerPricingUpdate: updatedOfferPricing,
            productPositions: [productPositions],
            autoUpdatePrices: updatedOfferPricingState.autoUpdatePrices,
            priceIsOutdated: updatedOfferPricingState.priceIsOutdated
          })
        }),
        tap(() => {
          this.resetStoredData();
        })
      );
  }

  onClose(): void {
    const offer = this.addLooseArticleToOfferComponent.offer;
    const positionId = this.addLooseArticleToOfferComponent.position.id;

    this.offerPositionService.deletePositions(offer, [positionId])
      .subscribe(() => {
        this.resetStoredData();
      });
  }

  private resetStoredData(): void {
    this.storeService.resetCustomPosition();
    this.storeService.resetLooseArticles();
  }
}
